import type { GrowTemplate } from "@pdfking/templates"
import { CompileGrow } from "@pdfking/templates"

import type { ImpositionSchema } from "#internal"

// Python `Grow.has_grow`: the grow grows the page on some axis.
const has_grow = (grow: GrowTemplate): boolean => CompileGrow(grow).opening_grow.length > 0

/** Mirrors Python `get_print_informations` → `print_info.is_book`. */
export const BookQ = ({ component_array: components }: ImpositionSchema): boolean => {
  if (components.length === 0) return false

  let has_inner = false
  let is_4up = false

  for (const [i, { grow_kind: grow, subjects, repetitions }] of components.entries()) {
    if (i === 0 && grow.is_cover) {
      // "si può specificare 1 sola ripetizione della copertina"
      if (subjects > 1 || repetitions > 1) return false
    } else if (grow.is_book) {
      has_inner = true
      is_4up = true
    } else if (!has_grow(grow)) {
      has_inner = true
      // "non e' possibile mischiare pagine sfuse e quartini"
      if (is_4up) return false
    } else {
      // "un libro deve avere una copertina all'inizio ed un interno"
      return false
    }
  }

  // "un libro deve avere un interno"
  return has_inner
}
